import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class CoordinatorStatisticsService {

  public isStatisticsHidden = true;

  constructor(private apiService: ApiService) { }

  public GetCommentData(companyId: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getCommentData}`;
    url = url.replace('{companyId}', companyId);
    return this.apiService.get(url);
  }

  public GetAbsenteeismData(companyId: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getAbsenteeismData}`;
    url = url.replace('{companyId}', companyId);
    return this.apiService.get(url);
  }

  public GetKpimData(companyId: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getKpiData}`;
    url = url.replace('{companyId}', companyId);
    return this.apiService.get(url);
  }

  public GetContactData(companyId: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getContactData}`;
    url = url.replace('{companyId}', companyId);
    return this.apiService.get(url);
  }
}
